// removed by extract-text-webpack-plugin
module.exports = {"subscription-settings-page":"subscription-settings-page","page-title":"page-title","form-group":"form-group","subscription-content":"subscription-content","subscription-expiration-date":"subscription-expiration-date","subscription-info":"subscription-info","subscription-feature":"subscription-feature"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/settings/scene/subscription/subscription.style.sass
// module id = N5cQ
// module chunks = 0